import {
  API_KEY_FORM_INITIAL,
  type ApiKeyFormData,
  BASIC_FORM_INITIAL,
  type BasicCredentialFormData,
  BEARER_TOKEN_FORM_INITIAL,
  type BearerTokenFormData,
  type ComplexLoginMultiFormData,
  CredentialType,
  makeComplexLoginMultiInitial,
  RECORDING_FORM_INITIAL,
  type RecordingCredentialFormData,
  STATIC_TOKEN_FORM_INITIAL,
  type StaticTokenFormData,
} from '@/sections/asset/components/tabs/credentials/credentialForms';

// State-less shared-subset of per-type credential form data. Mirrors the seed
// wizard's WizardCredentialData but intentionally EXCLUDES `recipeForm` — this
// bundle is the recipe-free subset shared across the non-wizard credential
// surfaces.
export interface CredentialBundle {
  selectedType: CredentialType;
  basicForm: BasicCredentialFormData;
  recordingForm: RecordingCredentialFormData;
  bearerTokenForm: BearerTokenFormData;
  apiKeyForm: ApiKeyFormData;
  staticTokenForm: StaticTokenFormData;
  complexLoginMulti: ComplexLoginMultiFormData;
}

// Builds a fresh credential bundle: every per-type form starts at its INITIAL
// constant, the active type defaults to `defaultType`, and COMPLEX_LOGIN's
// first identity's login URL is pre-filled from `webAppUrl`.
export function createCredentialBundle(
  defaultType: CredentialType,
  webAppUrl: string
): CredentialBundle {
  return {
    selectedType: defaultType,
    basicForm: BASIC_FORM_INITIAL,
    recordingForm: RECORDING_FORM_INITIAL,
    bearerTokenForm: BEARER_TOKEN_FORM_INITIAL,
    apiKeyForm: API_KEY_FORM_INITIAL,
    staticTokenForm: STATIC_TOKEN_FORM_INITIAL,
    complexLoginMulti: makeComplexLoginMultiInitial(webAppUrl),
  };
}
